/***
 * 姓名 :yjs
 * 创建时间:2021-5-17
 * 描述：对点击一级菜单进入其他站点的功能的补充--当登录异常时，需要跳转到登录页时，需要改变 hasLogin 字段的状态为 false
 * 更新记录:
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginStatusService {

  //将菜单树形设定为全局
  loginStatusUpdated: Subject<any> = new Subject<any>();
  constructor() { }
}
